<script>
  import config from '@/config'

  let keys = config.pageKeyBoardMap

  export default {
    data() {
      return {
        current: undefined,
        page: undefined,
        enabled: true,
        tab_diagnose: {
          _tabIndex: undefined,
          _tabNums: []
        }
      }
    },
    mounted() {
      document.onkeyup = (event) => {
        let allKeys = ["Enter", "ArrowLeft", "ArrowRight", "Tab"]
        // let allKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Enter"]
        if(allKeys.indexOf(event.key) < 0) {
          return
        }
        if(event.key === "Tab") {
          this.handleTab()
          return
        }

        if(!this.enabled) {
          console.log("捕获键盘事件禁用状态")
          return
        }

        if(!this.current) {
          this.focusKey(this.pageKeys.first, "next")
          return
        }

        if(event.key === "ArrowLeft") {
          this.preKey(event.key)
        } else if(event.key === "Enter" || event.key === "ArrowRight") {
          this.nextKey(event.key)
        }
      }
    },
    methods: {
      /* 处理输入 tab 的场景 */
      setTabData(page, data) {
        /*
        * "diagnose": {
           _tabIndex: undefined,
           _tabNums: []
         }
        * */
        Object.assign(this, {
          ['tab_'+page]: data
        })
      },
      handleTab() {
        let data = this.$data['tab_'+this.page]
        if(data) {
          if(this.page === "diagnose") {
            let tabLen = data._tabNums.length

            if(tabLen > 0) {
              this.tab_diagnose._tabIndex += 1
              if(this.tab_diagnose._tabIndex === tabLen) {
                this.tab_diagnose._tabIndex = 0
              }
              // tabKey是 关联组件中的变量
              this.tabKey = data._tabNums[this.tab_diagnose._tabIndex]
            }
          }
        }
      },
      clearKeyboardEvent(){
        document.onkeyup = null
      },
      keyboardSetCurrent(key) {
        this.current = key
      },
      /* KeyName 是 page.keys的字段，keyList 是所有的动态refs.name ColLen 数据并排成几列*/
      keyboardCalculateDynamicKey(keyName, keyList, colLen) {
        let i = 0

        let keyInfo = {}
        let keyLen = keyList.length

        let keyNameInfo = this.pageKeys.keys[keyName]
        while(i < keyLen) {
          let item = {}

          let itemPre = i - 1
          let itemNext = i + 1
          // let up = i - colLen
          // let down = i + colLen

          item.left = item.pre = "" + (itemPre >= 0 ? keyList[itemPre]: keyNameInfo.outPre)
          item.right = item.next = "" + (itemNext < keyLen ? keyList[itemNext]: keyNameInfo.outNext)
          // item.up = "" + (up >= 0 ? keyList[up]: keyNameInfo.outPre)
          // item.down = "" + (down < keyLen ? keyList[down]: keyNameInfo.outNext)

          keyInfo[''+keyList[i]] = item
          if(i === 0 ) {
            keyInfo[`${keyName}.first`] = {redirect: "" + keyList[i]}
          }
          if(i === keyLen - 1) {
            keyInfo[`${keyName}.end`] = {redirect: "" + keyList[i]}
          }
          i += 1
        }

        this.pageKeys.keys = Object.assign(this.pageKeys.keys, keyInfo)
      },
      keyboardSetPage(page) {
        this.pageKeys = keys[page]
        this.current = undefined
        this.page = page
      },
      passHidenKey(key, type) {
        let domVm = this.$refs[key]
        if(domVm) {
          return [domVm, key]
        } else {
          let keyInfo = this.pageKeys.keys[key]
          if(!keyInfo) {
            return [null, null]
          }
          if(type === "next") {
            if("next" in keyInfo) {
              return this.passHidenKey(keyInfo.next, "next")
            }
          } else if(type === "pre") {
            if("pre" in keyInfo) {
              return this.passHidenKey(keyInfo.pre, "pre")
            }
          }
          return [null, null]
        }
      },
      focusKey(key, type) {
        let keyInfo = this.pageKeys.keys[key]
        if(keyInfo.redirect) {
          key = keyInfo.redirect
        }
        let domVm
        [domVm, key] = this.passHidenKey(key, type)
        if(!domVm) {
          return false
        }

        if(!domVm.$el && domVm[0].$el) {
          domVm = domVm[0]
        }
        console.log(domVm)

        let focusElement = ["ant-input", "ant-input-number", "ant-calendar"]
        if(focusElement.find(item => domVm.$el.className.indexOf(item) >= 0)){
          domVm.focus()
        } else {
          domVm.$el.click()
        }

        this.keyboardSetCurrent(key)
      },
      nextKey(eventKey) {
        let current = this.pageKeys.keys[this.current]
        let nextKey = current.next

        if(eventKey === "ArrowRight") {
          nextKey = current.right
        }
        if(nextKey) {
          this.focusKey(nextKey, "next")
        }
      },
      preKey(eventKey) {
        let current = this.pageKeys.keys[this.current]

        let preKey = current.pre
        if(eventKey === "ArrowLeft") {
          preKey = current.left
        }

        if(preKey) {
          this.focusKey(preKey, "pre")
        }
      },
      keyboardDisableKey() {
        this.enabled = false
      },
      keyboardEnableKey() {
        this.enabled = true
      }
    },
    destroyed() {
      this.clearKeyboardEvent()
    }
  }
</script>
